//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const contacts = [ {
  id: 1,
  name: 'Ruddy Jedrzej',
  isi: 'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Distinctio <br/> possimus tenetur repellendus laudantium quasi molestias porro ex sint, libero ipsum accusamus debitis sed in, nam voluptatibus architecto error veniam voluptatum.',
  email: 'rjedrzej0@discuz.net',
  letter: 'R',
  read : false
}, {
  id: 2,
  name: 'Mallorie Alessandrini',
  isi: 'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Distinctio possimus tenetur repellendus laudantium quasi molestias porro ex sint, libero ipsum accusamus debitis sed in, nam voluptatibus architecto error veniam voluptatum.',
  email: 'malessandrini1@marketwatch.com',
  letter: 'M',
  read : true
}, {
  id: 3,
  name: 'Elisabetta Wicklen',
  isi: 'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Distinctio possimus tenetur repellendus laudantium quasi molestias porro ex sint, libero ipsum accusamus debitis sed in, nam voluptatibus architecto error veniam voluptatum.',
  email: 'ewicklen2@microsoft.com',
  letter: 'E',
  read : true
}, 
{
  id: 4,
  name: 'Seka Fawdrey',
  isi: 'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Distinctio possimus tenetur repellendus laudantium quasi molestias porro ex sint, libero ipsum accusamus debitis sed in, nam voluptatibus architecto error veniam voluptatum.',
  email: 'sfawdrey3@wired.com',
  letter: 'S',
  read : true
} ,
{
  id: 5,
  name: 'Seka Fawdrey',
  isi: 'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Distinctio possimus tenetur repellendus laudantium quasi molestias porro ex sint, libero ipsum accusamus debitis sed in, nam voluptatibus architecto error veniam voluptatum.',
  email: 'sfawdrey3@wired.com',
  letter: 'S',
  read : true
} ,
{
  id: 6,
  name: 'Seka Fawdrey',
  isi: 'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Distinctio possimus tenetur repellendus laudantium quasi molestias porro ex sint, libero ipsum accusamus debitis sed in, nam voluptatibus architecto error veniam voluptatum.',
  email: 'sfawdrey3@wired.com',
  letter: 'S',
  read : true
} ,
{
  id: 7,
  name: 'Seka Fawdrey',
  isi: 'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Distinctio possimus tenetur repellendus laudantium quasi molestias porro ex sint, libero ipsum accusamus debitis sed in, nam voluptatibus architecto error veniam voluptatum.',
  email: 'sfawdrey3@wired.com',
  letter: 'S',
  read : true
} ,
]

 
export default {
    data (){
        return {
            contacts,
            hasError:false,
            search:'',
            current:3,
        }
    },
    computed: {

        computedClass() {
            var aa =  this.contacts.read
            console.log('ajhska' + aa);
            
            // let className = 'bg-blue'; 
            // return className;
            }        
    },
}
